<template>
  <div class="row">
    <p><i class="nc-icon nc-alert-circle-i" style="margin-right: 5px" />Are you sure you want to requeue all <strong>{{data.count}}</strong> messages in the <strong>{{data.name}}</strong> queue?</p>
    <p-checkbox v-model="confirm">I understand what I'm doing and wish to proceed</p-checkbox>
    <div class="col-md-12 text-center">
      <button :disabled="!confirm" @click="requeueMessages" class="btn btn-fill btn-info btn-wd btn-danger">Requeue</button>
    </div>
  </div>
</template>

<script>
  export default {
    props: ['data'],
    data () {
      return {
        confirm: false
      }
    },
    methods: {
      requeueMessages () {
        this.$emit('close')
      }
    }
  }
</script>

<style scoped>

</style>
